export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
